<script setup lang="ts">
const { t, tm, rt } = useI18n()
</script>

<template>
  <div class="bg-white shadow-2xl shadow-black/5 lg:rounded-b-[5rem]">
    <section class="mx-auto max-w-screen-xl px-4 py-8 lg:px-8 lg:py-16">
      <div class="overflow-clip rounded-[1.875rem] border border-gray-200 bg-[#F8F8F0]">
        <div class="relative overflow-clip rounded-b-[1.875rem]  bg-[#33343f] lg:bg-transparent">
          <UiImageWithOverlay
            :src="`${S3_ASSETS_URL}/home/cta-01.jpg`"
            class="aspect-video size-full object-cover object-right"
            container-class="!absolute inset-0 hidden lg:block"
            direction="to-left"
            role="presentation"
          />

          <div class="isolate grid w-full place-items-center gap-y-5 text-balance px-8 py-7 text-center text-white lg:max-w-screen-sm lg:place-items-start lg:gap-y-8 lg:px-16 lg:py-14 lg:text-left">
            <h3 class="text-2xl font-medium lg:text-5xl">
              {{ t('home.section.dashboard_preview.title') }}
            </h3>

            <p class="text-base text-white/70 lg:text-lg">
              {{ t('home.section.dashboard_preview.description') }}
            </p>

            <UiButton
              class="group w-full max-w-xs lg:max-w-max"
              color="accent"
              as-child
            >
              <RouterLink :to="{ name: '/free-demo' }">
                {{ t('home.section.dashboard_preview.action') }}

                <UiIcon
                  name="arrow-outward-rounded"
                  class="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                />
              </RouterLink>
            </UiButton>
          </div>

          <img
            :src="`${S3_ASSETS_URL}/home/cta-01.jpg`"
            class="block aspect-video size-full rounded-t-[1.875rem] object-cover object-right lg:hidden"
            role="presentation"
          >
        </div>

        <div class="grid gap-x-16 gap-y-8 p-8 md:auto-cols-fr md:grid-flow-col">
          <div
            v-for="(item, itemIndex) in tm('home.section.dashboard_preview.items')"
            :key="itemIndex"
            class="grid grid-flow-col place-content-start gap-2 text-balance lg:grid-flow-row"
          >
            <UiIcon
              name="star-dotted"
              class="mt-0.5 text-2xl text-orange-500 lg:mt-0"
            />

            <h4 class="hidden text-xl font-medium md:max-w-60 lg:block">
              {{ rt(item.title) }}
            </h4>

            <p class="hidden text-gray-600 lg:block">
              {{ rt(item.description) }}
            </p>

            <div class="block lg:hidden">
              <h4 class="text-xl font-medium">
                {{ rt(item.title) }}
              </h4>

              <p class="text-gray-600">
                {{ rt(item.description) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
